import { COLORS } from 'helpers/globals'

const button = {
  padding: '.3rem 1rem',
  borderRadius: '1rem',
  color: 'white',
  fontSize: '1.2rem',
  fontWeight: 400,
  cursor: 'pointer'
}

export default {
  instructions: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: 435,
    height: '100%',
    overflowY: 'auto',
    padding: 0
  },
  topUiControls: {
    fontSize: '1.6rem',
    padding: '.5rem',
    backgroundColor: COLORS.tertiary,
    borderBottom: `1px solid ${COLORS.quaternary}`,
    textAlign: 'center'
  },
  label: {
    lineHeight: '3.5rem',
    color: 'black',
    marginLeft: '.8rem',
    marginBottom: '.8rem'
  },
  instructionList: {
    marginLeft: '2rem',
    paddingLeft: '.5rem',
    marginBottom: '1rem',
    lineHeight: '1.5rem',
    listStylePosition: 'outside',
    color: 'black'
  },
  spacer: {
    paddingTop: '20rem'
  },
  cancelButton: {
    ...button,
    background: 'red',
    marginLeft: '2rem',
    '&:hover': { background: '#E60000' }
  }
}



// WEBPACK FOOTER //
// ./src/components/WallInstructions/style.js